import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import { ThreeDots } from "react-loader-spinner";

const base64 = require("base-64");

function AdminDetails({
  baseUrl,
  lastUrl,
  leaderboardUrl,
  canShowLeaderboard = false,
}) {
  const [url3Data, setUrl3Data] = useState([]);
  const [url4Data, setUrl4Data] = useState([]);
  const [url5Data, setUrl5Data] = useState([]);
  const [chart2, setChart2] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const pairs = document.cookie.split(";");
  let cookies = {};
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split("=");
    cookies[(pair[0] + "").trim()] = unescape(pair.slice(1).join("="));
  }
  const authToken = base64.encode(cookies.userid + ":" + cookies.ver);
  const shouldDisplayLeaderboard = Boolean(leaderboardUrl) && canShowLeaderboard;

  const handleLeaderboardClick = () => {
    if (!shouldDisplayLeaderboard) return;
    window.open(leaderboardUrl, "_blank", "noreferrer");
  };

  const chartData = [
    ["Task", "Hours per total"],
    [
      "LSD",
      url3Data[3]?.getTotalUniqueUsers
        ? parseInt(url3Data[3].getTotalUniqueUsers)
        : 0,
    ],
    [
      "ENG",
      url3Data[2]?.getTotalUniqueUsers
        ? parseInt(url3Data[2].getTotalUniqueUsers)
        : 0,
    ],
    [
      "GUJ",
      url3Data[1]?.getTotalUniqueUsers
        ? parseInt(url3Data[1].getTotalUniqueUsers)
        : 0,
    ],
    [
      "ARB",
      url3Data[0]?.getTotalUniqueUsers
        ? parseInt(url3Data[0].getTotalUniqueUsers)
        : 0,
    ],
  ];

  const chart2Data = chart2.map((item) => ({
    value: parseInt(item.avgTime),
  }));

  useEffect(() => {
    const fetchUrlData = async () => {
      if (!lastUrl) {
        return;
      }

      setIsLoading(true);
      setError(null);

      let myHeaders = new Headers();
      myHeaders.append("Authorization", "Basic " + authToken);
      let requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

      try {
        const url3 = `${baseUrl}langauge_wise_user_count/all/${lastUrl}/all`;
        const response = await fetch(url3, requestOptions);
        const data = await response.json();
        setUrl3Data(data.data);

        const url4 = `${baseUrl}total_completed_unique_user/all/${lastUrl}/all`;
        const response4 = await fetch(url4, requestOptions);
        const data4 = await response4.json();
        setUrl4Data(data4.data);

        const url5 = `${baseUrl}total_unique_user/all/${lastUrl}/all`;
        const response5 = await fetch(url5, requestOptions);
        const data5 = await response5.json();
        setUrl5Data(data5.data);

        const url6 = `${baseUrl}total_unique_user_paper_wise/all/${lastUrl}/all`;
        const response6 = await fetch(url6, requestOptions);
        const data6 = await response6.json();
        setChart2(data6.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message || "Failed to fetch data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchUrlData();
  }, [baseUrl, lastUrl]);
  if (isLoading) {
    return (
      <div className="admin-table text-center">
        <ThreeDots color="darkblue" size={50} />
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-table text-center">
        <p className="text-danger">Error: {error}</p>
      </div>
    );
  }

  if (!url3Data.length) {
    return (
      <div className="admin-table">
        <h4
          style={{
            fontSize: "1em",
            margin: "15px",
            fontWeight: "bold",
            color: "rgba(18,21,78,.7)",
          }}
        >
          ADMIN DETAILS
        </h4>
        <hr className="underline" />
        <p className="text-muted text-center">No data available</p>
      </div>
    );
  }

  return (
    <>
      {url3Data.length === 0 ? (
        <div className="admin-table text-center">
          <ThreeDots color="darkblue" size={50} />
        </div>
      ) : (
        <div className="admin-table">
          <div className="row">
            <div className="col-md-8">
              <div
                className="data-container mb-4"
                style={{ fontWeight: "700", color: "#495057" }}
              >
                Total Unique Users
                <div
                  className="widget-numbers text-success"
                  style={{ fontSize: "1.8rem" }}
                >
                  {url5Data}
                </div>
              </div>

              <div
                className="data-container mb-4"
                style={{ fontWeight: "700", color: "#495057" }}
              >
                Total Completed Users
                <div
                  className="widget-numbers text-success"
                  style={{ fontSize: "1.8rem" }}
                >
                  {url4Data}
                </div>
              </div>
              <hr className="underline" />
              <div className="row">
                <div className="col-md-6">
                  {url3Data[0] && (
                    <div className="data-container mb-4">
                      Total ARB Users
                      <div
                        className="widget-numbers text-danger"
                        style={{ fontSize: "1.8rem" }}
                      >
                        {url3Data[0]?.getTotalUniqueUsers || ""}
                      </div>
                    </div>
                  )}
                  {url3Data[1] && (
                    <div className="data-container">
                      Total GUJ Users
                      <div
                        className="widget-numbers text-danger"
                        style={{ fontSize: "1.8rem" }}
                      >
                        {url3Data[1]?.getTotalUniqueUsers || ""}
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  {url3Data[2] && (
                    <div className="data-container mb-4">
                      Total ENG Users
                      <div
                        className="widget-numbers text-danger"
                        style={{ fontSize: "1.8rem" }}
                      >
                        {url3Data[2]?.getTotalUniqueUsers || ""}
                      </div>
                    </div>
                  )}
                  {url3Data[3] && (
                    <div className="data-container">
                      Total LSD Users
                      <div
                        className="widget-numbers text-danger"
                        style={{ fontSize: "1.8rem" }}
                      >
                        {url3Data[3]?.getTotalUniqueUsers || ""}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {shouldDisplayLeaderboard && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    marginTop: "1rem",
                  }}
                >
                  <a
                    href={leaderboardUrl}
                    target="_blank"
                    rel="noreferrer"
                    // style={{
                    //   padding: "10px 16px",
                    //   borderRadius: "6px",
                    //   // backgroundColor: "#457B9D",
                    //   color: "blue",
                    //   fontWeight: 600,
                    //   textDecoration: "none",
                    //   display: "inline-block",
                    // }}
                  >
                    View Leaderboard
                  </a>
                </div>
              )}
            </div>
            <div className="col-md-4">
              <div
                style={{ margin: "0.2em", width: "100%", overflow: "hidden" }}
              >
                <PieChart
                  hideLabels={true}
                  className="pie-chart-legend-marker"
                  series={[
                    {
                      data: chartData.slice(1).map(([label, value]) => ({
                        id: label,
                        value,
                        label,
                      })),
                      innerRadius: 40,
                      outerRadius: 100,
                      paddingAngle: 1,
                      cornerRadius: 7,
                      startAngle: -90,
                      endAngle: 360,
                      highlightScope: {
                        faded: "global",
                        highlighted: "item",
                      },
                      faded: {
                        innerRadius: 30,
                        additionalRadius: -30,
                        color: "gray",
                      },
                    },
                  ]}
                  width={300}
                  height={200}
                />
              </div>

              <div className="row-md-4">
                <PieChart
                  series={[
                    {
                      data: chart2Data,
                      innerRadius: 40,
                      outerRadius: 100,
                      paddingAngle: 1,
                      cornerRadius: 5,
                      startAngle: -90,
                      endAngle: 360,
                      highlightScope: {
                        faded: "global",
                        highlighted: "item",
                      },
                      faded: {
                        innerRadius: 30,
                        additionalRadius: -30,
                        color: "gray",
                      },
                    },
                  ]}
                  width={300}
                  height={200}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AdminDetails;
